import { Box, Container, Typography, Button } from "@mui/material";
import ScrollReveal from "./ScrollReveal";
import { useTranslation } from "react-i18next"; // ← ADD

export default function StillHaveQuestions({ onClaimClick }) {
  const { t, i18n } = useTranslation(); // ← ADD
  const isArabic = i18n.language === "ar"; // ← ADD

  return (
    <ScrollReveal delay={0.1} duration={1.0}>
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4, lg: 2 },
          mb: "6%",
          mt: "2%",
          direction: isArabic ? "rtl" : "ltr", // ← ADD
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              backgroundColor: "#FAF5FF",
              borderRadius: 4,
              py: { xs: 5, sm: 6, md: 6 },
              px: { xs: 3, sm: 4, md: 6 },
              textAlign: isArabic
                ? { xs: "right", sm: "right", md: "center", lg: "center" }
                : { xs: "left", sm: "left", md: "center", lg: "center" }, // ← FIX
            }}
          >
            <Typography
              variant="h4"
              component="h2"
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: "1.4rem",
                  sm: "1.6rem",
                  md: "1.75rem",
                  lg: "1.5rem",
                },
                color: "#111827",
                mb: 2,
                fontFamily: "var(--font-plusjakarta)",
              }}
            >
              {t("stillHaveQuestions.title")} {/* ← REPLACE */}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#4B5563",
                fontSize: { xs: "0.9rem", sm: "0.95rem", md: "1rem" },
                mb: 4,
                maxWidth: "700px",
                mx: { xs: 0, sm: 0, md: "auto" },
                fontFamily: "var(--font-outfit)",
              }}
            >
              {t("stillHaveQuestions.description")} {/* ← REPLACE */}
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: isArabic
                  ? { xs: "flex-start", sm: "center", md: "center" }
                  : { xs: "flex-start", sm: "flex-start", md: "center" }, // ← FIX
              }}
            >
              <Button
                variant="contained"
                onClick={onClaimClick}
                sx={{
                  backgroundColor: "#9f5fff",
                  color: "white",
                  textTransform: "none",
                  fontSize: { xs: "0.64rem", sm: "0.95rem", md: "1rem" },
                  fontWeight: 500,
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  boxShadow: "none",
                  transition: "transform 0.2s ease-in-out",
                  fontFamily: "var(--font-outfit)",
                  "&:hover": {
                    backgroundColor: "#9f5fff",
                    boxShadow: "none",
                    transform: "scale(1.05) translateY(-2px)",
                  },
                }}
              >
                {t("stillHaveQuestions.cta")} {/* ← REPLACE */}
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
    </ScrollReveal>
  );
}
